import { render, staticRenderFns } from "./PricingOnboarding.vue?vue&type=template&id=44d22774&scoped=true&"
import script from "./PricingOnboarding.vue?vue&type=script&lang=js&"
export * from "./PricingOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./PricingOnboarding.vue?vue&type=style&index=0&id=44d22774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d22774",
  null
  
)

export default component.exports